module.exports = __webpack_public_path__ + "img/people.98159aa5.png";